export default [
  'red',
  'pink',
  'orange',
  'teal',
  'yellow',
  'green',
  'purple',
  'blue',
  'cyan',
] as const;
